/*
 * @Description:
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-03-16 13:43:35
 * @LastEditors: zhangle
 * @LastEditTime: 2023-02-23 14:30:51
 */
import TsaSignPasswordV2 from '@/components/signPasswordV2/index.vue'
let $vm
const plugin = {
  install (vue, pluginOptions = {}) {
    const SignPasswordV2 = vue.extend(TsaSignPasswordV2)
    if (!$vm) {
      $vm = new SignPasswordV2({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const signPasswordV2 = {
      show (options = {}) {
        $vm.show = true
        Object.keys(options).map(key => {
          $vm[key] = options[key]
        })
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaSignPasswordV2) {
      vue.prototype.$TsaSignPasswordV2 = signPasswordV2
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/signPasswordV2/index.js